import React from 'react';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import _get from 'lodash/get';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import selectStyles from '../Select.module.scss';

function RequiredToReadOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected } = restProps;
  const value = _get(restProps, 'data.value', false) as boolean;
  const leftIcon = _get(
    restProps,
    'data.leftIcon',
    'import_contacts',
  ) as string;
  return (
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(selectStyles.requiredToReadOption, {
        active: isSelected,
      })}
    >
      <span className={selectStyles.requiredToReadIconWrapper}>
        <MaterialIcon icon={leftIcon} symbolsOutlined />
        {value && (
          <span className={selectStyles.requiredToReadBadge}>
            <MaterialIcon icon="emergency" size="md-12" />
          </span>
        )}
      </span>
      {children}
    </DefaultSelectComponents.Option>
  );
}

export default RequiredToReadOption;
